module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921041151_T.3fa69cdf.jpg";